export const CHAT_FAILURE_MESSAGE = 'Chat failed. Please try again.';

type ErrorToast = {
  error: (message: string, options?: { reportError?: boolean }) => void;
};

export function notifyChatFailure(toast: ErrorToast): void {
  toast.error(CHAT_FAILURE_MESSAGE, { reportError: false });
}
